<template>
  <div id="app" ref="appBody">
    <!-- <span @click="clickFn">测试报警</span> -->
    <!--定位-->
    <!-- <PositioningAddress></PositioningAddress> -->
    <topMenu ref="topMenu" @menuTypeChange="hideLeft = false"></topMenu>
    <div class="routerWindow" ref="routerWindow" :style="windowStyle">
      <leftMenu2 v-if=" menuStore.state.showLeftMenu && menuList != undefined && menuList.length != 0"
        :dataList="menuList" @checkItem="checkItemLeft($event)" :nowMenu='nowMenu'></leftMenu2>
      <separationMenuLeft
        v-if="menuStore.state.showSeparationMenuLeft && separationMenuLeftData != undefined && separationMenuLeftData.length != 0"
        :style="getSeparationLeftMenu" ref="separationMenuLeft" :dataList="separationMenuLeftData"
        :autoSelectMethod="autoSelectMethod" @checkItem="checkItemLeft($event)"></separationMenuLeft>
      <navTabs ref="navTabs" :menuArr='menuArr' @nowMenu_fn='nowMenu_fn' v-if="menuStore.state.showLeftMenu"></navTabs>
      <router-view :class="['router',{'router-active':!bookmark}]" :style="routerStyle"
        v-loading="getLoad"></router-view>
      <!-- <router-view class='router router-active' :style="routerStyle" v-loading="getLoad"></router-view> -->

    </div>
  </div>
</template>
<script src="https://unpkg.com/vue-baidu-map"></script>
<script type="text/javascript" src="http://api.map.baidu.com/api?v=2.0&ak=S6zkx4nmO3Hmp75L8SweEdAEYvvyK8GG"></script>
<!--引入Javascript API GL，参数说明参见下文-->
<script charset="utf-8" src="https://map.qq.com/api/js?v=2.exp&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77"></script>
<script>
  (function(doc,win) {
    var docEl=doc.documentElement,
      resizeEvt="orientationchange" in window? "orientationchange":"resize",
      recalc=function() {
        var clientWidth=docEl.clientWidth;

        if(!clientWidth) return;
        if(clientWidth>=1754) {
          docEl.style.fontSize=100*(clientWidth/1919)+"px";
        } else {
          docEl.style.fontSize="91px";
        }
      };

    if(!doc.addEventListener) return;
    win.addEventListener(resizeEvt,recalc,false);
    doc.addEventListener("DOMContentLoaded",recalc,false);
  })(document,window);
  import leftMenu2 from "@/components/module/menu/leftMenu2.vue"
  import topMenu from "@/components/module/menu/topMenu.vue"
  import navTabs from "@/layout/components/Tagsview/index.vue"
  // import tianjinTopMenu from "@/components/module/menu/tianjinTopMenu.vue"
  import separationMenuTop from "@/components/module/menu/separationMenuTop.vue"
  // import themePop from "@/components/module/menu/themePop.vue"

  import separationMenuLeft from "@/components/module/menu/separationMenuLeft.vue"
  // import PositioningAddress from '@/components/module/map/PositioningAddress.vue'
  var axios=require('axios')
  export default {
    name: 'app',
    components: {
      topMenu,
      separationMenuTop,
      separationMenuLeft,
      // PositioningAddress,
      leftMenu2,
      navTabs
      // themePop,
    },
    // tianjinTopMenu,
    props: [],
    data () {
      return {
        hideLeft: false,
        menuSeparated: false,
        menuArr: [],
        nowMenu: [],
        nowSkinFlag: true
      }
    },
    created () {
      debugPage=this

    },
    mounted () {
      if(localStorage.getItem("token")!=undefined&&localStorage.getItem("token")!="undefined") {
        this.$store.userStore.commit("setNowUserCode",localStorage.getItem('nowWedoSystemUserCode'))
        //获取用户单位信息
        this.$store.unitStore.commit("getUnitTree")
        this.$store.orderGroupStore.commit('getOrderGroupTree')
        this.$store.menuStore.commit("getMenuList")

        let userDetailed=JSON.parse(localStorage.getItem('userDetailed'))
        //刷新的时候让websocket重连
        this.$wedoWebSocketClient.connect(userDetailed.webSocketUrl,userDetailed.pkid)
        this.$store.deviceStore.commit("getReadDeviceTreeWithTypeNos",36)
        //获取电表、水表
        this.$store.deviceStore.commit("getDeviceTreeByappTypeNos",1001)
      }
      //每隔一段时间刷新一下token有效期，为了避免第一天来不及刷新，间隔做的比默认24小时有效期短一些
      addNewTask('refreshTokenEveryDay',0,60*60*1000,-1,() => {
        try {
          var token=localStorage.getItem('token')
          if(!token) {
            token=sessionStorage.getItem("token")
          }
          if(token&&token!="undefined") {
            debugPage.$api.userApi.expireToken()
          }
        } catch(e) {
          err(e)
        }
      })
      //2小时之后重新连接socket
      addNewTask('socketLogin',0,2*60*60*1000,-1,() => {
        let userDetailed=JSON.parse(localStorage.getItem('userDetailed'))
        this.$wedoWebSocketClient.connect(userDetailed.webSocketUrl,userDetailed.pkid)
      })
      //注入webSocket心跳回调
      this.$wedoWebSocketClient.addListener('heartBreak',(data,socketBean,getMessage) => {
        if(data.func==0&&data.cmd==0) {
          //心跳由这里统一处理
          socketBean.send(getMessage(0,0,'',data.tag))
          this.$store.cacheStore.state.socketState=true
          log('心跳收发正常!')
          return
        }
        if(data.func==2&&data.cmd==0) {
          //svg版本更新,需要更新svg树
          this.$store.svgStore.commit('updateSvgTree',data.data)
          //也需要更新菜单中的svg版本
          this.$store.menuStore.commit('updateSvg',data.data)
          return
        }
        if(data.func==4&&data.cmd==0) {
          //debugger;
          //是事件推送
          try {
            this.dealEvent(data)
          } catch(e) {
            err('事件解析异常')
            err(e)
          }
          return
        }
        if(data.func==1) {
          switch(data.cmd) {
            case 0:
              if(data.state==this.$wedoWebSocketClient.WedoWebSocketState.STATE_OK) {
                log("登录成功")
              } else {
                err("登录失败: "+data.data)
                this.$wedoWebSocketClient.disConnect()
              }
              return
            case 1:
              //注销了
              this.$wedoWebSocketClient.disConnect()
              return
            case 2:
              //异地登录被顶下来
              this.$dialogMethod.openAgreeDialog('异地登录',"您的账号在另一个网页端登录，您被迫下线，如果非您本人授权，则账号密码可能已经泄露！",undefined,undefined,
                false)
              toLogin()
              return
          }
        }
        //非心跳则由当前页面处理，当然也可以另外添加监听器获取
        //svg版本变更
        if(debugPage!=undefined&&debugPage.hasOwnProperty("acceptWebSocketMsg")) {
          try {
            debugPage.acceptWebSocketMsg(data,socketBean,getMessage)
          } catch(e) {
            err('消息处理异常:')
            err(e)
          }
        } else {
          log("未处理消息")
          log(data)
        }

      })
      this.initAllSkin()
    },
    destroyed () {
      this.$wedoWebSocketClient.disConnect()
    },
    computed: {
      skinFlag () {
        return this.$store.cacheStore.state.skinFlag;
      },
      bookmark () {
        return this.$store.menuStore.state.bookmark
      },
      socketStore () {
        return this.$store.socketStore
      },
      getLoad () {
        return this.$store.cacheStore.state.load
      },
      getLeftMenu () {
        var data={
          'height': 'auto',
          'min-width': '2rem',
          'max-width': '3rem',
          'border-width': '0 .01rem 0 0',
          'background-size': '100% 100%',
          'overflow-y': 'auto'
        }
        if(this.hideLeft) {
          data['min-width']='.5rem'
        }
        return data
      },
      getSeparationLeftMenu () {
        var data={
          'margin-right': '10px',
          'min-width': '1.9rem',
          'max-width': '3rem'
        }
        if(!this.menuStore.state.showSeparationMenuLeft) {
          return {}
        }
        return data
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      menuStore () {
        return this.$store.menuStore
      },
      cache () {
        return this.menuStore.state
      },
      menuList () {

        return this.menuStore.getters.getMenu
      },
      separationMenuLeftData () {
        return this.menuStore.state.separationMenuLeftData
      },
      windowStyle () {
        var topHeight=0.5
        //if(this.cache.showTopMenu) {
        if(false) {
          return {
            'height': 'calc(100% - '+topHeight+'rem)',
          }
        } else {
          return {
            'height': '100%',
          }
        }
      },
      routerStyle () {
        if(this.cache.showSeparationMenuLeft) {
          return {
            'width': 'calc(100% - 2rem)',
            'margin-top': '35px;'
          }
        } else {
          return {
            'width': '100%',
            'margin-top': '35px;'
          }
        }
      }
    },
    watch: {
      menuList (val) {
        // console.log("修改菜单",val);
        this.menu_fn()
      },
      bookmark () {},
      skinFlag () {
        this.initAllSkin()
      },
    },
    methods: {
      clickFn () {
        var d=[{
          description: "气元一4035厂房通信中断",
          deviceName: "气元一4035厂房",
          deviceNo: 18,
          eventLevel: 1,
          eventlevel: 1,
          eventtime: 1686107082000,
          linkObject: "devicestate.气元一4035厂房",
          timeText: "2023-06-07 11:04:42",
          typeName: "故障报警",
          unitId: "8643062D4DAF4FA0B1A4EA0A71713ED4",
          unitName: "昆明英派尔科技",
          uuid: "4186834284645974016"
        }];
        this.$dialogMethod.openEventAlarm(d)
      },
      //取菜单数组
      menu_fn () {
        var newArr=[]
        var arr=this.menuList
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.next.length!=0) {

                getStr(row.next)
              } else {
                newArr.push(row)
                // console.log("row.ChildDatas",row.rightname);
              }
            })
          }
          getStr(arr)
        }
        recursiveFunction()
        this.menuArr=newArr
      },
      //当前菜单
      nowMenu_fn (menu) {
        this.nowMenu=menu
      },
      autoSelectMethod (item,index) {
        var nowMenuSort=localStorage.getItem('nowMenuSort')
        if(nowMenuSort!=undefined) {
          if(item.sort==nowMenuSort) {
            return true
          }
          return false
        }
        if(item.hasSonMenu!=1) {
          return true
        }
        return false
      },
      changeLeft (hideName) {
        this.hideLeft=hideName
      },
      checkItem (menu) {

        if(!menu.hasOwnProperty('next')||isempty(menu.next)) {
          this.menuStore.commit('setNowMenu',menu)
          localStorage.setItem('nowMenuSort',menu.sort)
          this.$router.push(menu.webpage)
        } else {
          this.menuStore.commit('setNowMenu',menu)
        }
      },
      checkItemLeft (menu) {
        //跳转到别的网站
        if(menu.hasSonMenu==2) {
          window.open(menu.webpage,'_blank');
        } else {
          this.menuStore.commit('setNowMenu',menu)
          this.$router.push(menu.webpage)
          localStorage.setItem('nowMenuSort',menu.sort)
        }
      },
      dealEvent (msg) {
        //debugger;
        var data=JSON.parse(msg.data)
        if(data.hasOwnProperty("eventlevel")) {
          data.eventLevel=data.eventlevel
        }
        if(data.hasOwnProperty('eventtime')) {
          data.timeText=new Date(data.eventtime).formatByTime('-')
        }
        switch(data.eventLevel) {
          case 0:
            //消息,弹窗就好了 要改成右上角的消息列表
            this.socketStore.commit("addMsg",data)
            break
          case 1:
            //预警
            this.socketStore.commit("addRealTimeEvent",data)
            this.$dialogMethod.openEventAlarm(this.socketStore.getters.getRealTimeEventList)
            break
          case 2:
            //告警
            this.socketStore.commit("addRealTimeEvent",data)
            this.$dialogMethod.openEventAlarm(this.socketStore.getters.getRealTimeEventList)
            break
        }
      },
      initAllSkin () {
        var styleName=""
        if(localStorage.getItem("themeName")) { //如果有主题颜色了，就继续沿用
          //  console.log("主题名称",localStorage.getItem("themeName"));
          styleName=localStorage.getItem("themeName")
        } else { //如果还没有主题颜色，就默认是科技蓝
          localStorage.setItem("themeName",'科技蓝');
          styleName='科技蓝'
        }

        //获取当前系统皮肤
        setTimeout(() => {
          this.$store.cacheStore.commit('getWebConfig')
          // console.log("获取当前系统皮肤",this.$store.cacheStore.commit('getWebConfig'));
        },1000)
        /*获取配置信息*/
        this.$api.systemApi.getWebConfig(styleName,respon => {
          // console.log("获取配置信息",styleName,respon);
          if(respon.Style=="通用") {
            this.initSkin('科技蓝','kejilan')
          } else {
            // this.initSkin('魅力红', '')
            this.initSkin(respon.Style,'')
          }
        })
        //加载中科看板专用皮肤
        axios({
          url: './static/中科泛在定制/看板/UbiquitousOverviewChartSkin.json?version='+new Date().formatByDate(),
        }).then(respon => {
          var data=JSON.parse(JSON.stringify(respon.data))
          echarts.registerTheme('UbiquitousOverviewChartSkin',data)
        })
        //加载东杰看板专用皮肤
        axios({
          url: './static/杭州东杰定制/看板/dongjieEchart.json?version='+new Date().formatByDate(),
        }).then(respon => {
          var data=JSON.parse(JSON.stringify(respon.data))
          echarts.registerTheme('dongjieEchart',data)
        })
      },
      initSkin (skinName,skinTag) {
        //路径
        var path="./skin/"+skinName+"/"
        var skinPath=path+"skin.css?version="+new Date().formatByDate()
        var resourcesPath='./static/image/'+skinName+'/'
        //注册echart皮肤
        axios({
          url: path+'echartSkinConfig.json?version='+new Date().formatByDate(),
        }).then(respon => {
          var data=JSON.parse(JSON.stringify(respon.data))
          echarts.registerTheme(skinTag,data)
        })
        //注入颜色样式等
        axios({
          url: path+"colorMap.json",
        }).then(respon => {
          var data=JSON.parse(JSON.stringify(respon.data))
          this.$store.resourcesStore.commit("addSkin",{
            skinTag,
            skinName,
            resourcesPath,
            skinPath,
            colorMap: data
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .mybtns {
    position: absolute;
    top: 10%;
    right: 0;
    z-index: 99999;
    transition: 0.3s;

    &.mybtns-active {
      right: 20%;
    }
  }

  // /deep/.el-scrollbar__wrap .el-scrollbar__view {
  // 	width: 100%;
  // }
  /deep/.el-select-dropdown__list {
    width: 100% !important;
  }

  /deep/.el-icon-setting {
    font-size: 16px !important;
  }

  /deep/.el-icon-close {
    font-size: 16px !important;
  }

  #app {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  .routerWindow {
    position: relative;
    display: flex;
    align-content: center;
    width: 100%;
    justify-content: space-between;
  }

  .router {
    flex-grow: 1;
    height: calc(100% - 85px) !important;
    display: inline-block;
    overflow: auto;
    margin-top: 40px;
    background-color: #E6EEF5;
    transition: 0.35s;
    padding: 8px 10px 15px 8px !important;
    box-sizing: border-box;
    // z-index: 100;
  }

  .routerWindow .router-active {
    height: calc(100% - 45px) !important;
    margin-top: 0px;
    // box-sizing: border-box;
  }

  .leftMenu {
    height: auto;
    min-width: .5rem;
    max-width: 3rem;
    border-width: 0 .01rem 0 0;
    background-size: 100% 100%;
    overflow-y: auto;
  }
</style>